import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import NoteList from "./note-list"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import { colorCode } from "../../functions/middle-category-style"

export const Report = () => {
  const data = useStaticQuery (
    graphql`
    query ReportQuery {
      caseStudies: allMicrocmsNotes(
        limit: 3
        sort: {fields: [publishedAt], order: DESC}
        filter: {large_category: {eq: "事例集"}}
      ) {
        edges {
          node {
            notesId
            title
            large_category
            middle_category {
              id
              name
              display_color
            }
            thumbnail {
              url
            }
            tags {
              id
              name
              type
            }
          }
        }
      }
    }`
  )

  return (
    <div className="contents report_container">
      <div className="contents_in">
        <div className="padding_sp">{/* スマホのみ隙間 */}


          <div className="inner_title">
            <div>
              <h4 className="maintitle">Report</h4>
              <p className="subtitle">プログラムの導入事例や過去のセミナー映像をご覧いただけます</p>
            </div>
            <div className="more"><Link to="/note/case-study"><span>view more</span></Link></div>
          </div>
            
            <NoteList data={data.caseStudies.edges} />



        </div>{/* padding_sp スマホのみ隙間 */}
      </div>{/* contents_in */}
    </div>
  )
}
